import { fetchSearchMeta } from 'shared/services/fetchSearchMeta';
import { TAsyncThunkAction } from 'shared/types/redux';
import { prepareJsonQuery } from './utils';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { selectLocation } from 'shared/selectors/location';
import { setSearchMeta, setSearchMetaIsLoading } from 'shared/slices/searchMeta';
import { debounce } from 'throttle-debounce';
import { ISearchMeta } from 'shared/types/searchMeta';

const debouncedFetchSearchMeta = debounce(500, ({ resolver, context, parameters }) =>
  fetchSearchMeta(context, parameters).then(resolver),
);

export const updateSearchMeta = (): TAsyncThunkAction => async (dispatch, getState, context) => {
  const state = getState();

  const jsonQuery = prepareJsonQuery({ jsonQuery: selectJsonQuery(state), location: selectLocation(state) });

  dispatch(setSearchMetaIsLoading(true));

  const newMeta: ISearchMeta | null = await new Promise(resolve =>
    debouncedFetchSearchMeta({ resolver: resolve, context, parameters: { jsonQuery } }),
  );

  if (newMeta) {
    dispatch(setSearchMeta(newMeta));
  } else {
    dispatch(setSearchMetaIsLoading(false));
  }
};
